import update from 'immutability-helper';
import toPairs from 'lodash/toPairs';
import mapValues from 'lodash/mapValues';
import * as c from '../../constants/engineering';

export const defaultState = {};

export const normalizeWorkAreaData = (data) => {
  let { status, inputs, 'node-id': nodeId, ...normalized } = data;

  normalized.nodeId = nodeId;
  normalized.open = status === 'on';
  if (inputs) {
    normalized.open = true;
    normalized.inputs = mapValues(data.inputs, (value) =>
      value === 'nil' ? '' : value
    );
  }

  return normalized;
};

const mergeWorkAreaData = (state, nodes) => {
  return toPairs(nodes).reduce((newState, [node, data]) => {
    if (newState.hasOwnProperty(node)) {
      return update(newState, {
        [node]: { $merge: normalizeWorkAreaData(data) },
      });
    } else {
      return update(newState, {
        [node]: { $set: normalizeWorkAreaData(data) },
      });
    }
  }, state);
};

const workAreas = (state = defaultState, action) => {
  switch (action.type) {
    case c.ENG_INIT:
      const structure = mergeWorkAreaData(
        {},
        action.data.engineering.workAreas
      );
      if (action.data.nodes) {
        return mergeWorkAreaData(structure, action.data.nodes);
      } else {
        return structure;
      }

    case c.ENG_UPDATE_WORK_AREAS:
      return mergeWorkAreaData(state, action.workAreas);

    case c.ENG_OPEN_WORK_AREA:
      return update(state, {
        [action.node]: { $merge: { open: true, loading: true } },
      });

    case c.ENG_CLOSE_WORK_AREA:
      return update(state, { [action.node]: { open: { $set: false } } });

    case c.ENG_SEND_WORK_AREA:
    case c.ENG_UPDATE_SKETCHER:
      if (action.node in state) {
        return update(state, { [action.node]: { $merge: { loading: true } } });
      } else {
        return state;
      }

    case c.ENG_CLEAR_WORK_AREAS:
      return mapValues(state, (v) => ({ ...v, open: false }));

    case c.ENG_SEND_WORK_AREA_SUCCESS:
    case c.ENG_SEND_WORK_AREA_FAILURE:
    case c.ENG_UPDATE_SKETCHER_SUCCESS:
    case c.ENG_UPDATE_SKETCHER_FAILURE:
      if (action.node in state) {
        return update(state, { [action.node]: { $merge: { loading: false } } });
      } else {
        return state;
      }

    default:
      return state;
  }
};

export default workAreas;
